import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { showDeliveryOptions } from '../../entry/state/utils';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { DeliveryOptionsDropdown } from './DeliveryOptionsDropdown';

const DeliveryOptionsContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-end'
});

type DeliverySectionProps = {
    orderId: number;
    user: AuthenticatedUser;
    currentStatus: number;
    normalImagesAvailable: boolean;
    totalDeliveredCount: number;
    isApprovalInProgress: boolean;
    approvalCompleted: boolean;
};

export function DeliverySection({
    orderId,
    user,
    currentStatus,
    normalImagesAvailable,
    totalDeliveredCount,
    isApprovalInProgress,
    approvalCompleted
}: DeliverySectionProps) {
    if (showDeliveryOptions(currentStatus, user)) {
        return (
            <DeliveryOptionsContainer>
                <DeliveryOptionsDropdown
                    user={user}
                    photoStatus={currentStatus}
                    normalImagesAvailable={normalImagesAvailable}
                    numberOfDeliverableImages={totalDeliveredCount}
                    orderId={orderId}
                />
            </DeliveryOptionsContainer>
        );
    }

    if (isApprovalInProgress && approvalCompleted) {
        return (
            <DeliveryOptionsContainer>
                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    sx={{ minWidth: '320px', height: '38px', borderRadius: 0 }}
                />
            </DeliveryOptionsContainer>
        );
    }

    return null;
}
